// Official LIVYVIO brand assets (approved, high-resolution, transparent PNG/WebP).
// Do not redraw or recolor. Keep all references centralized here.
export const BRAND = {
  // Running sprout mascot (square, transparent). Used selectively.
  mascot:
    "https://customer-assets-v7afamib.emergentagent.net/job_wellness-platform-v1-1/artifacts/p85gphc0_ChatGPT%20Image%2026%20ago%202026%2C%2002_36_47.png",
  // Horizontal LIVYVIO wordmark (transparent). Used in header/footer.
  wordmark:
    "https://customer-assets-v7afamib.emergentagent.net/job_wellness-platform-v1-1/artifacts/obs2z7rm_ChatGPT%20Image%2026%20ago%202026%2C%2002_56_51.webp",
};
